import type { PieChartProps } from "./PieChart.d";
import PieChartPrimary from "./PieChartPrimary";
import PieChartSecondary from "./PieChartSecondary";

const PieChart = ({ variant, text, chartValue }: PieChartProps) =>
  variant === "primary"
    ? <PieChartPrimary variant={variant} text={text} chartValue={chartValue} />
    : <PieChartSecondary variant={variant} text={text} chartValue={chartValue}/>

export default PieChart;
